export default "__VITE_ASSET__CX3EwMHu__"